/**
 * `load` for door data: a failed request resolves to `{ error: true }` instead
 * of failing the controller. The loaders do not cache a failure, so the
 * page's retry asks the API again.
 */
const tryLoad = (load, name, args) =>
  load(name, args).catch(() => ({ error: true }));

export default tryLoad;
